import { ArrowLeftOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import classes from './TopNavigationBar.module.scss';

interface TopNavigationBarProps {
  title?: string;
  leftButton?: boolean | JSX.Element;
  leftButtonAction?: () => void;
  rightButton?: JSX.Element;
  borderBottom?: boolean;
}

const TopNavigationBar: FC<TopNavigationBarProps> = ({
  title,
  leftButton,
  leftButtonAction,
  rightButton,
  borderBottom,
}) => {
  const navigate = useNavigate();

  const onClickLeftButton = leftButtonAction || (() => navigate(-1));

  return (
    <header className={`${classes.topNavigationBarContainer} ${borderBottom ? classes.borderBottom : ''}`}>
      {leftButton ? (
        typeof leftButton === 'boolean' ? (
          <ArrowLeftOutlined
            onClick={onClickLeftButton}
            style={{ fontSize: 20, width: 48, justifyContent: 'center' }}
          />
        ) : (
          leftButton
        )
      ) : (
        <span className={classes.emptyBox} />
      )}
      <h3>{title}</h3>
      {rightButton ? rightButton : <span className={classes.emptyBox} />}
    </header>
  );
};

export default TopNavigationBar;
